import { render, staticRenderFns } from "./Col.vue?vue&type=template&id=a1b09320&scoped=true&"
import script from "./Col.vue?vue&type=script&lang=js&"
export * from "./Col.vue?vue&type=script&lang=js&"
import style0 from "./Col.vue?vue&type=style&index=0&id=a1b09320&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b09320",
  null
  
)

export default component.exports